(function() {
  'use strict';

  angular.module('blocks.lunr', []);
})();
